<template>
  <div class="good">
    <Goback></Goback>
    <swipe :autoplay="3000" class="swipe">
      <swipe-item v-for="(item, idx) in good.feature_cover_urls" :key="idx">
        <img :src="item" alt="图片">
      </swipe-item>
    </swipe>
    <div class="good-detail" v-if="good && good.id">
      <div>
        <div class="good-title">
          <span class="title">{{good.title}}</span>
        </div>
        <div class="activity-tag-container">
          <span class="good-price">￥{{good.price}}</span>
          <tag v-for="(item, idx) in good.activity_tags" :key="idx" type="danger" class="goods-activity-tag">
            {{item}}
          </tag>
        </div>
        <div class="good-desc">{{good.description}}</div>
        <div class="goods-ship-price" v-if="good.ship_price_desc">
          <span class="goods-yun">{{good.ship_price_desc}}</span>
        </div>
      </div>
    </div>

    <MomentGoodsRemarkCell :good="good"></MomentGoodsRemarkCell>
    <div class="detail" ref="detail">
      <img v-for="(item, idx) in good.detail_image_urls" :key="idx" v-lazy="item" class="good-img-container">
    </div>

    <sku v-model="showBase"
         :sku="sku"
         :goods="goods"
         :goods-id="goodsId"
         :hide-stock="sku.hide_stock"
         :initial-sku="initialSku"
         :reset-stepper-on-hide="true"
         :reset-selected-sku-on-hide="true"
         @buy-clicked="onBuyClicked"
         @add-cart="onAddCartClicked"
         @stepper-change="getCount"
         close-on-click-overlay
         :safe-area-inset-bottom="true"
    ></sku>
    <goods-action safe-area-inset-bottom>
      <goods-action-icon icon="shop" text="主页" @click="toShopPage"/>
      <goods-action-icon icon="chat" @click="toMessage" text="客服"/>
      <goods-action-icon icon="cart" text="购物车" to="/cart"/>
      <goods-action-button @click="showSkuModal" type="warning" text="加入购物车"/>
      <goods-action-button @click="showSkuModal" type="danger" text="立即购买" primary/>
    </goods-action>
  </div>
</template>

<script>
  import {
    GoodsActionButton,
    Toast,
    GoodsActionIcon,
    Swipe,
    CellGroup,
    SwipeItem,
    Cell,
    Row,
    Col,
    Tag,
    GoodsAction,
    Sku,
    Popup
  } from "vant"
  import Goback from "../common/Goback";
  import MomentGoodsRemarkCell from "../forum/moment/MomentGoodsRemarkCell";

  export default {
    name: "GoodsDetail",
    data() {
      return {
        loading: true,
        cartCount: '',
        showBase: false,
        sku: {},
        skuMap: {},
        goods: {},
        count: 1,
        initialSku: {},
        goodsId: 0,
        showQrCode: false,
        good: {},
        relatedItems: []
      };
    },
    components: {
      MomentGoodsRemarkCell,
      Goback,
      Toast,
      GoodsActionIcon,
      GoodsActionButton,
      Swipe,
      SwipeItem,
      CellGroup,
      Cell,
      Row,
      Col,
      Tag,
      GoodsAction,
      Sku,
      Popup
    },
    mounted() {
      this.init()
    },
    computed: {},
    methods: {
      init() {
        this.goodsId = this.$route.params.id;
        this.$store.dispatch("GetGoodsById", {"id": this.goodsId}).then((data) => {
          this.good = data;
          if (!this.good) {
            Toast.fail("商品不存在")
          }

          this.goods = {
            title: this.good.title,
            picture: this.good.cover_url
          };

          let skuList = this.good.sku_list
          let skuTree = this.good.sku_tree

          for (let i = 0; i < skuList.length; i++) {
            this.skuMap[skuList[i].id] = skuList[i]
          }

          if (skuList && skuList.length > 0) {
            this.initialSku = skuList[0]
          }

          this.sku = {
            tree: skuTree,
            list: skuList,
            messages: [],
            price: this.good.price,
            none_sku: false,
            min_price: '1.00',
            max_price: '1.00',
            hide_stock: true
          };
        }, () => {
          Toast('网络错误');
        });
      },
      onBuyClicked(skuObj) {
        this.doAddCart(skuObj, "click_buy")
      },
      onAddCartClicked(skuObj) {
        this.doAddCart(skuObj, "click_add")
      },

      doAddCart(skuObj, action) {
        if (!skuObj || !skuObj.selectedSkuComb || !skuObj.selectedSkuComb.id) {
          Toast.success('添加失败');
          return
        }

        if (skuObj.selectedSkuComb.stock_num <= 0) {
          Toast.success('商品无库存');
          return
        }

        let skuExtra = ""
        let skuInf = this.skuMap[skuObj.selectedSkuComb.id]
        if (skuInf) {
          if (skuInf.property_desc) {
            skuExtra = skuInf.property_desc
          }

          if (skuInf.property_desc_2) {
            skuExtra += " " + skuInf.property_desc_2
          }
        }
        let obj = {
          Cartcount: this.count,
          skuCombId: skuObj.selectedSkuComb.id,
          goodId: this.good.id,
          price: skuObj.selectedSkuComb.price / 100,
          coverUrl: this.good.cover_url,
          title: this.good.title,
          skuExtra: skuExtra,
          activityTags: this.good.activity_tags || [],
        }

        if (action === "click_buy") {
          this.$store.commit("SetOrderGood", [obj])
          this.$router.push({
            "path": '/cart',
            "query": {
              "from": "buy",
            }
          });
        } else if (action === "click_add") {
          this.$store.commit("AddCartGood", obj)
          this.showBase = false;
          Toast.success('添加成功');
        }
      },
      getCount(value) {
        this.count = value;
      },
      showSkuModal() {
        this.showBase = true;
      },

      toMessage() {
        this.$router.push("/message")
      },

      toShopPage() {
        this.$router.push("/_tab_novel?list_type=goods_main_wt")
      },
    },
    watch: {
      good() {
      }
    }
  };
</script>

<style lang="scss" scoped>
  .good {
    padding-bottom: 50px;
    background: #f2f2f2;
  }

  .swipe {
    min-height: 275px;
    background: #f2f2f2;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .good-detail {
    padding: 12px 12px;
    background: white;

    .activity-tag-container {
      display: flex;
      align-items: center;
      padding: 8px 0;
    }

    .goods-activity-tag {
      margin-left: 12px;
    }

    .goods-activity-tag:first-child {
      margin-left: 0;
    }

    .good-title {
      color: rgba(31, 31, 31, 0.88);
      font-size: 18px;
      padding: 6px 0;

      .title {
        font-weight: bold;
      }
    }

    .good-desc {
      padding: 6px 0;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 1.5;
    }

    .good-price {
      color: red;
      font-size: 20px;
    }

    .goods-ship-price {
      padding: 12px 0;
      border-bottom: 1px solid #f2f2f2;
    }


    .goods-yun {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .good-img-container {
    margin: 0 0;
    padding: 0 0;
  }

  .detail {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }

  .detail img {
    display: block;
    width: 100%;
    height: auto;
  }

  .goods-detail-title {
    text-align: center;
    color: rgba(0, 0, 0, 0.65);
    padding: 8px 0;
  }
</style>
